// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a33u","questions":"styles_questions__14aVB","footer":"styles_footer__2vir8"};